//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import LeftCol from './LeftCol.vue';
// import TopNav from './TopNav.vue';
// import RightCol from './RightCol.vue';
import AppFooter from './AppFooter.vue';

export default {
  name: 'MainContainer',
  components: {
    AppFooter,
    // RightCol,
    // TopNav,
    // LeftCol,
  },
  props: {
    zIndex: {
      type: String,
      default: '100',
    },
  },
};
